import { render, staticRenderFns } from "./main.vue?vue&type=template&id=1003aa8a&scoped=true"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"
import style0 from "./main.vue?vue&type=style&index=0&id=1003aa8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1003aa8a",
  null
  
)

export default component.exports